import { ProductViewConfigurator } from '~/types/configurator';
import configuratorChoices from '~/data/configuratorChoices/bagConfiguratorChoices';

let label;
let description;

export default {
    controls: [
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [
                configuratorChoices.colors.black,
                configuratorChoices.colors.customWithoutPattern,
            ],
            detailsModalLabel: 'Color options:',
        },
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Material',
            choices: [configuratorChoices.materials.standard],
            detailsModalLabel: 'Material options:',
        },
        {
            key: 'finish',
            keyLabel: 'finish',
            label: 'Finish',
            choices: [configuratorChoices.finishes.matte],
            detailsModalLabel: 'Finish options:',
        },
        {
            key: 'size',
            keyLabel: 'size',
            label: 'Size',
            choices: [
                {
                    label: (label = '4.82”w × 6”h'),
                    detailsModalLabel: label,
                    value: '4.82-x-6',
                    description: (description =
                        'Approximately 4 oz. *Fill testing recommended'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Size options:',
        },
    ],
} as ProductViewConfigurator;
